import type { TableColumnType } from 'antd';

const noWrapCell = () => ({ style: { whiteSpace: 'nowrap' } as const });

export const noWrapColumn = {
  onHeaderCell: noWrapCell,
  onCell: noWrapCell,
} satisfies Pick<TableColumnType<unknown>, 'onHeaderCell' | 'onCell'>;
